<template>
    <v-container fluid>
        <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
                Dashboard Default
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- Bottone di salvataggio -->
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        @click="save"
                        small
                        v-bind="attrs"
                        v-on="on"
                        class="ml-5"
                    >
                        <v-icon color="success"> mdi-floppy </v-icon>
                    </v-btn>
                </template>
                <span>Salva</span>
            </v-tooltip>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-row>
            <v-col cols="12" class="pa-5">
                <v-autocomplete
                    :items="dashboards"
                    v-model="dashboardSel"
                    item-text="descrizione"
                    item-value="id_elemento"
                ></v-autocomplete>
            </v-col>
        </v-row>

        <SnackbarQV ref="SnackbarQV" />
    </v-container>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
    components: {
        SnackbarQV,
    },
    data() {
        return {
            dashboards: [],
            dashboardSel: null,
            idTabella: -1,
        };
    },
    methods: {
        async save() {
            let request = {
                controller: "Global",
                method: "PUT",
                richiesta: {
                    action: "settabella",
                    token: localStorage.user_token,
                    id_utente: localStorage.id,
                    tabella: [{id_tabella: this.idTabella, tipo: "DASHBOARD_LOGISTIC", val_int: this.dashboardSel}],
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    console.log(res.status);
                    this.$refs.SnackbarQV.print(
                        "success",
                        "Dashboard default salvato"
                    );
                })
                .catch((err) => {
                    this.$refs.SnackbarQV.print(
                        "error",
                        `${JSON.parse(err.response.data.message).result}.`
                    );
                });
        },
        async GetDefault() {
            let request = {
                controller: "Global",
                method: "POST",
                richiesta: {
                    action: "gettabella",
                    token: localStorage.getItem("user_token"),
                    tipo: "DASHBOARD_LOGISTIC",
                    filter: "validita = 1",
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.dashboardSel =
                            res.data != null && res.data != ""
                                ? res.data[0].val_int
                                : null;
                        this.idTabella =
                            res.data != null && res.data != ""
                                ? res.data[0].id_tabella
                                : -1;
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        },
        async GetDashboard() {
            let request = {
                controller: "graph",
                method: "POST",
                richiesta: {
                    action: "getdashboard",
                    token: localStorage.getItem("user_token"),
                },
            };

            await this.$store
                .dispatch("api6", request)
                .then((res) => {
                    this.dashboards = res.data.result;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
    mounted() {
        this.GetDashboard();
        this.GetDefault();
    },
};
</script>
